package com.wintermar.inspection.core.data

import com.apollographql.apollo.api.http.HttpRequest
import com.apollographql.apollo.api.http.HttpResponse
import com.apollographql.apollo.network.http.HttpInterceptor
import com.apollographql.apollo.network.http.HttpInterceptorChain
import com.wintermar.inspection.Platform
import com.wintermar.inspection.feature.data.remote.request.HeaderRequest
import com.wintermar.inspection.graphql.LoginMutation
import com.wintermar.inspection.util.global_navigation.GlobalNavigationBus
import com.wintermar.inspection.util.global_navigation.NavigationEvent

class TokenInterceptor(
    private val authorizationEncryption: AuthorizationEncryption,
    private val appSetting: AppSetting,
    private val platform: Platform,
    private val authRefreshApi: AuthRefreshApi,
    private val navigationBus: GlobalNavigationBus
) : HttpInterceptor {

    private suspend fun execute(
        request: HttpRequest,
        chain: HttpInterceptorChain,
        token: String
    ): HttpResponse {
        val bearer = "Bearer ${platform.clientType.clientName}:${
            authorizationEncryption.getFinalEncrypt(token)
        }"
        val newRequest = request.newBuilder()
            .addHeader(
                HeaderRequest.AUTHORIZATION,
                bearer
            )
            .build()
        return chain.proceed(newRequest)
    }

    override suspend fun intercept(
        request: HttpRequest,
        chain: HttpInterceptorChain
    ): HttpResponse {
        val isLoginOperation = request.headers.any {
            it.name.equals(HeaderRequest.OPERATION, ignoreCase = true) &&
                    it.value.equals(LoginMutation.OPERATION_NAME, ignoreCase = true)
        }
        val currentToken = if (isLoginOperation) "" else appSetting.authToken.orEmpty()
        var response = execute(request = request, chain = chain, token = currentToken)
        if (response.statusCode == 401 && !isLoginOperation) {
            val refreshToken = appSetting.refreshToken.orEmpty()
            if (refreshToken.isNotEmpty()) {
                val bearer = "Bearer ${platform.clientType.clientName}:${
                    authorizationEncryption.getFinalEncrypt(refreshToken)
                }"
                val res = try {
                    authRefreshApi.refresh(bearer)
                } catch (t: Throwable) {
                    Result.failure(t)
                }
                res.fold(
                    onSuccess = { newData ->
                        appSetting.setNewToken(
                            authToken = newData.first ?: "",
                            refreshToken = newData.second ?: ""
                        )
                        response = execute(request, chain, newData.first ?: "")
                    },
                    onFailure = {
                        onLogout()
                    }
                )
            } else {
                onLogout()
            }
        }
        return response
    }

    private suspend fun onLogout() {
        appSetting.logout()
        navigationBus.emit(NavigationEvent.Logout)
    }
}
